// extracted by mini-css-extract-plugin
export var discountCodeBubbleContainer = "_jq-0";
export var discountCodeInput = "_jq-1";